import { useAuth } from '../../context/AuthContext';

const AVATAR_COUNT = 15;

export const AVATARS = Array.from({ length: AVATAR_COUNT }, (_, i) => ({
    id: String(i + 1).padStart(2, '0'),
    src: `/img/avatars/avatar_${String(i + 1).padStart(2, '0')}.png`,
}));

const UserAvatar = ({ size = 'md', className = '', showNotificationDot = false }) => {
    const { user } = useAuth();
    const avatarId = user?.dashboardPrefs?.avatarId;
    const avatar = avatarId ? AVATARS.find(a => a.id === avatarId) : null;
    const hasUnread = showNotificationDot && ((user?.unreadNotifications || 0) + (user?.unreadMessages || 0) > 0);

    const sizeClasses = {
        xs: 'w-6 h-6',
        sm: 'w-8 h-8',
        md: 'w-10 h-10',
        lg: 'w-12 h-12',
        xl: 'w-16 h-16',
    };

    const textSizes = {
        xs: 'text-[10px]',
        sm: 'text-xs',
        md: 'text-sm',
        lg: 'text-base',
        xl: 'text-xl',
    };

    const dotSizes = {
        xs: 'w-1.5 h-1.5',
        sm: 'w-2 h-2',
        md: 'w-2.5 h-2.5',
        lg: 'w-3 h-3',
        xl: 'w-3.5 h-3.5',
    };

    const dot = hasUnread && (
        <span className={`absolute top-0 right-0 ${dotSizes[size] || dotSizes.md} bg-red-500 rounded-full border-2 border-white dark:border-gray-900`} />
    );

    if (avatar) {
        return (
            <div className={`relative ${sizeClasses[size] || sizeClasses.md} ${className}`}>
                <img
                    src={avatar.src}
                    alt=""
                    className="w-full h-full rounded-full object-cover"
                />
                {dot}
            </div>
        );
    }

    return (
        <div className={`relative ${sizeClasses[size] || sizeClasses.md} ${className}`}>
            <div className="w-full h-full rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center">
                <span className={`${textSizes[size] || textSizes.md} font-bold text-white`}>
                    {user?.name?.[0]?.toUpperCase() || user?.email?.[0]?.toUpperCase() || '?'}
                </span>
            </div>
            {dot}
        </div>
    );
};

export default UserAvatar;
